import { render, staticRenderFns } from "./ViewGlobal.vue?vue&type=template&id=10fe89e8&scoped=true&"
import script from "./ViewGlobal.vue?vue&type=script&lang=js&"
export * from "./ViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe89e8",
  null
  
)

export default component.exports